module.exports = __webpack_public_path__ + "static/relax-482c358335408593cefcbcd6a5a208ec.svg";